var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 71,
    viewBox: "0 0 200 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1145",
    "data-name": "Rectangle 1145",
    width: 23.452,
    height: 22.403,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1161",
    "data-name": "Rectangle 1161",
    width: 83.9,
    height: 14.3,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(-821 -539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933",
    transform: "translate(820.802 538.702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1143",
    "data-name": "Rectangle 1143",
    transform: "translate(0.198 0.298)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 71,
    rx: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 199,
    height: 70,
    rx: 12.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925",
    transform: "translate(38.338 13.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M615.26,1019.8l-7.079-.835,2.917.344-.109.4a12.613,12.613,0,0,1-12.179,9.289c-.274,0-.553-.009-.827-.027l-.405-.026.543-2.73-1.4,7.053a.815.815,0,0,0,1.2.871l6.341-3.528,6.341,3.528a.815.815,0,0,0,1.2-.871l-1.4-7.053,5.335-5.011a.815.815,0,0,0-.462-1.4",
    transform: "translate(-592.528 -1011.836)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M5.454,17.135c.274.018.553.027.827.027A12.572,12.572,0,0,0,14,14.525a12.666,12.666,0,0,0,2.754-2.942,12.547,12.547,0,0,0,1.7-3.71l.109-.4L15.653,7.13,12.46.466a.815.815,0,0,0-1.469,0L7.8,7.13.72,7.965a.815.815,0,0,0-.462,1.4l5.335,5.011-.543,2.73Z",
    transform: "translate(0 -0.004)",
    fill: "#ffd400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924-2",
    "data-name": "Group 924",
    transform: "translate(25.091 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040-2",
    "data-name": "Path 2040",
    d: "M615.26,1019.8l-7.079-.835,2.917.344-.109.4a12.613,12.613,0,0,1-12.179,9.289c-.274,0-.553-.009-.827-.027l-.405-.026.543-2.73-1.4,7.053a.815.815,0,0,0,1.2.871l6.341-3.528,6.341,3.528a.815.815,0,0,0,1.2-.871l-1.4-7.053,5.335-5.011a.815.815,0,0,0-.462-1.4",
    transform: "translate(-592.528 -1011.836)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041-2",
    "data-name": "Path 2041",
    d: "M5.454,17.135c.274.018.553.027.827.027A12.572,12.572,0,0,0,14,14.525a12.666,12.666,0,0,0,2.754-2.942,12.547,12.547,0,0,0,1.7-3.71l.109-.4L15.653,7.13,12.46.466a.815.815,0,0,0-1.469,0L7.8,7.13.72,7.965a.815.815,0,0,0-.462,1.4l5.335,5.011-.543,2.73Z",
    transform: "translate(0 -0.004)",
    fill: "#ffd400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924-3",
    "data-name": "Group 924",
    transform: "translate(50.183 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040-3",
    "data-name": "Path 2040",
    d: "M615.26,1019.8l-7.079-.835,2.917.344-.109.4a12.613,12.613,0,0,1-12.179,9.289c-.274,0-.553-.009-.827-.027l-.405-.026.543-2.73-1.4,7.053a.815.815,0,0,0,1.2.871l6.341-3.528,6.341,3.528a.815.815,0,0,0,1.2-.871l-1.4-7.053,5.335-5.011a.815.815,0,0,0-.462-1.4",
    transform: "translate(-592.528 -1011.836)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041-3",
    "data-name": "Path 2041",
    d: "M5.454,17.135c.274.018.553.027.827.027A12.572,12.572,0,0,0,14,14.525a12.666,12.666,0,0,0,2.754-2.942,12.547,12.547,0,0,0,1.7-3.71l.109-.4L15.653,7.13,12.46.466a.815.815,0,0,0-1.469,0L7.8,7.13.72,7.965a.815.815,0,0,0-.462,1.4l5.335,5.011-.543,2.73Z",
    transform: "translate(0 -0.004)",
    fill: "#ffd400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924-4",
    "data-name": "Group 924",
    transform: "translate(75.274 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040-4",
    "data-name": "Path 2040",
    d: "M615.26,1019.8l-7.079-.835,2.917.344-.109.4a12.613,12.613,0,0,1-12.179,9.289c-.274,0-.553-.009-.827-.027l-.405-.026.543-2.73-1.4,7.053a.815.815,0,0,0,1.2.871l6.341-3.528,6.341,3.528a.815.815,0,0,0,1.2-.871l-1.4-7.053,5.335-5.011a.815.815,0,0,0-.462-1.4",
    transform: "translate(-592.528 -1011.836)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041-4",
    "data-name": "Path 2041",
    d: "M5.454,17.135c.274.018.553.027.827.027A12.572,12.572,0,0,0,14,14.525a12.666,12.666,0,0,0,2.754-2.942,12.547,12.547,0,0,0,1.7-3.71l.109-.4L15.653,7.13,12.46.466a.815.815,0,0,0-1.469,0L7.8,7.13.72,7.965a.815.815,0,0,0-.462,1.4l5.335,5.011-.543,2.73Z",
    transform: "translate(0 -0.004)",
    fill: "#ffd400"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_924-5",
    "data-name": "Group 924",
    transform: "translate(100.366 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040-5",
    "data-name": "Path 2040",
    d: "M615.26,1019.8l-7.079-.835,2.917.344-.109.4a12.613,12.613,0,0,1-12.179,9.289c-.274,0-.553-.009-.827-.027l-.405-.026.543-2.73-1.4,7.053a.815.815,0,0,0,1.2.871l6.341-3.528,6.341,3.528a.815.815,0,0,0,1.2-.871l-1.4-7.053,5.335-5.011a.815.815,0,0,0-.462-1.4",
    transform: "translate(-592.528 -1011.836)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2041-5",
    "data-name": "Path 2041",
    d: "M5.454,17.135c.274.018.553.027.827.027A12.572,12.572,0,0,0,14,14.525a12.666,12.666,0,0,0,2.754-2.942,12.547,12.547,0,0,0,1.7-3.71l.109-.4L15.653,7.13,12.46.466a.815.815,0,0,0-1.469,0L7.8,7.13.72,7.965a.815.815,0,0,0-.462,1.4l5.335,5.011-.543,2.73Z",
    transform: "translate(0 -0.004)",
    fill: "#ffd400"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959",
    transform: "translate(58.248 45.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2182",
    "data-name": "Path 2182",
    d: "M0,7.1V.7H3.1V6.9c0,1.5.4,2.2,1.7,2.2s1.7-.7,1.7-2.3V.6H9.6V6.9c0,3.1-1.8,4.6-4.8,4.6S0,10,0,7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2183",
    "data-name": "Path 2183",
    d: "M10.6,8.9h2.5c0,.6.3.9,1.1.9s1-.3,1-.6-.4-.6-1.5-.7c-2.1-.3-3-.9-3-2.5s1.5-2.6,3.4-2.6,3.3.7,3.5,2.5H15.2a.908.908,0,0,0-1-.8c-.6,0-.9.3-.9.6s.4.5,1.3.6c2.2.3,3.2.8,3.2,2.5s-1.4,2.7-3.6,2.7-3.5-.9-3.6-2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2184",
    "data-name": "Path 2184",
    d: "M18.5,7.6h0a4.042,4.042,0,0,1,4.2-4.2c2.3,0,4,1.2,4,4v.7H21.2a1.522,1.522,0,0,0,1.6,1.6c.9,0,1.3-.4,1.4-.9h2.5c-.2,1.8-1.6,2.8-4,2.8s-4.3-1.4-4.3-4Zm5.6-1a1.342,1.342,0,0,0-1.4-1.5q-1.35,0-1.5,1.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2185",
    "data-name": "Path 2185",
    d: "M27.9,3.6h2.7V5.2a2.457,2.457,0,0,1,2.5-1.7V6c-1.6,0-2.5.5-2.5,1.7v3.7H27.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2186",
    "data-name": "Path 2186",
    d: "M37.5.7h4.2c2.8,0,4.4,1.1,4.4,3.4A2.906,2.906,0,0,1,44.2,7l2.6,4.4H43.6L41.4,7.6h-.7v3.8H37.6V.7Zm4,4.9c1,0,1.5-.4,1.5-1.3S42.5,3,41.5,3h-1V5.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2187",
    "data-name": "Path 2187",
    d: "M47.2,9.2c0-1.8,1.6-2.6,4.2-2.6h.8V6.4c0-.8-.2-1.2-1-1.2a.959.959,0,0,0-1.1.9H47.6c.1-1.9,1.6-2.8,3.8-2.8s3.5.9,3.5,3v5.1H52.3v-.9A2.571,2.571,0,0,1,50,11.6a2.488,2.488,0,0,1-2.7-2.4Zm4.9-.5V8.2h-.7c-1.1,0-1.6.2-1.6.9s.3.7.9.7A1.221,1.221,0,0,0,52,8.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2188",
    "data-name": "Path 2188",
    d: "M56.6,8.9V5.4h-.9V3.6h.9V2h2.7V3.6h1.5V5.4H59.3V8.6c0,.6.3.8.8.8a1.719,1.719,0,0,0,.8-.1v2c-.3,0-.9.2-1.5.2-1.8,0-2.8-.9-2.8-2.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M62,1.4a1.5,1.5,0,0,1,3,0,1.5,1.5,0,0,1-3,0m.1,2.2h2.7v7.8H62.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M66.5,3.6h2.7V4.9a2.822,2.822,0,0,1,2.6-1.5c1.3,0,2.6.9,2.6,3v5.1H71.7V6.9c0-.9-.3-1.3-1.1-1.3s-1.3.5-1.3,1.5v4.4H66.6V3.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M75.4,11.4h2.7c.1.6.5,1,1.4,1a1.666,1.666,0,0,0,1.7-1.6V9.6A2.655,2.655,0,0,1,78.8,11c-1.8,0-3.3-1.4-3.3-3.8S77,3.3,78.8,3.3s2,.5,2.4,1.3V3.5h2.7v7.2c0,2.3-1.5,3.6-4.3,3.6s-3.9-1.1-4.1-2.9Zm5.9-4.2h0c0-1.2-.6-1.9-1.5-1.9s-1.5.7-1.5,1.8c0,1.2.6,1.9,1.5,1.9a1.636,1.636,0,0,0,1.6-1.8Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRating);
export default __webpack_public_path__ + "static/media/userRating.e290b3a757bebba6c01f8159c300e821.svg";
export { ForwardRef as ReactComponent };